import firebase from "firebase/compat/app";
import getGroupInfoById from "./getGroupInfoById";
import getUserInfoByUserId from "./getUserInfoByUserId";

const getChallengeGroupListDetails = async function(competition_id) {
  let db = firebase.firestore();

  const groupDetailsList = [];
  if (competition_id != undefined) {
    const groupSnapshot = await db
      .collection("wellness_competition")
      .doc(competition_id)
      .collection("groups")
      .get();
    groupSnapshot.forEach(async (doc) => {
      //get group info
      if (doc.exists && doc.id != "null") {
        const groupChallengeData = doc.data();
        let groupInfo = await getGroupInfoById(doc.id);
        if( groupInfo == undefined ){
          groupInfo = {
            name: 'Deleted group'
          };
        }
        groupInfo.id = doc.id;
        groupInfo.verifyInfo = groupChallengeData;
        groupInfo.admin = [];
        // get admin info
        if (groupInfo.owner != undefined) {
          const userInfo = await getUserInfoByUserId(groupInfo.owner);
          groupInfo.admin = userInfo;
        }
        groupDetailsList.push(groupInfo);
      }
    });
  }
  return groupDetailsList;
};
export default getChallengeGroupListDetails;
